import React, { useMemo } from "react";
import { cn, formatCurrency } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

interface PriceLabelProps {
  value?: number | null;
  decimalPlaces?: number;
  placeHolder?: string;
  loading?: boolean;
  className?: string;
  suffix?: string;
  noPrefix?: boolean;
}

const PriceLabel: React.FC<PriceLabelProps> = ({
  value,
  decimalPlaces = 2,
  placeHolder = "--",
  loading = false,
  className,
  suffix,
  noPrefix,
}) => {
  // precompute
  const numericValue = typeof value === "number" ? value : null;

  const colorClass = useMemo(() => {
    if (numericValue === null) return "";
    if (numericValue > 0) return "text-green-foreground";
    if (numericValue < 0) return "text-red-foreground";
    return "";
  }, [numericValue]);

  if (loading) {
    return <Skeleton className={cn("w-16 h-5", className)} />;
  }

  return (
    <span className={cn(colorClass, className)}>
      {numericValue !== null
        ? `${formatCurrency(numericValue, decimalPlaces, noPrefix)}${
            suffix ?? ""
          }`
        : placeHolder}
    </span>
  );
};

export default PriceLabel;
